import { useTranslation } from 'hooks/useTranslation'
import Image from 'next/image'
import { Stack } from 'components/Stack'
import { Text } from 'components/Text'
import { HeroRoot, Layout, MobileImageColumn, DesktopImageColumn, CopyColumn, Header } from './Hero.styles'
import heroD from '../../../../../public/assets/why-we-feed-raw/hero-d.webp'
import heroM from '../../../../../public/assets/why-we-feed-raw/hero-m.webp'

export const Hero = () => {
  const { t } = useTranslation()
  return (
    <HeroRoot role="banner">
      <Layout gap="0" direction={{ '@initial': 'column', '@bp2': 'row' }}>
        <MobileImageColumn>
          <Image
            objectFit="cover"
            height={266}
            width={500}
            src={heroM}
            alt={t('why-we-feed-raw:hero.image')}
            loading="eager"
            priority
          />
        </MobileImageColumn>
        <DesktopImageColumn>
          <Image
            objectFit="cover"
            layout="fill"
            src={heroD}
            alt={t('why-we-feed-raw:hero.image')}
            loading="eager"
            priority
          />
        </DesktopImageColumn>
        <CopyColumn justifyContent="center" direction="column" alignItems="center" gap="2">
          <Stack direction="column" alignItems="center" gap={{'@initial': '1', '@bp2': '2'}}>
            <Stack direction="column" gap="0">
              <Header>
                {t('why-we-feed-raw:hero.title')}
              </Header>
            </Stack>
            <Stack display={{ '@initial': 'none', '@bp2': 'flex' }} direction="column" gap="0" alignItems="center">
              <Text size="body">
                {t('why-we-feed-raw:hero.subtitle.line1')}
              </Text>
              <Text size="body">
                {t('why-we-feed-raw:hero.subtitle.line2')}
              </Text>
            </Stack>
            <Stack display={{ '@initial': 'flex', '@bp2': 'none' }} direction="column" gap="0" alignItems="center">
              <Text align='center' size="body">
                {t('why-we-feed-raw:hero.subtitle-m.line1')}
              </Text>
              <Text align='center' size="body">
                {t('why-we-feed-raw:hero.subtitle-m.line2')}
              </Text>
            </Stack>
          </Stack>
        </CopyColumn>
      </Layout>
    </HeroRoot>
  )
}

Hero.displayName = 'WhyWeFeedRawHero'
